module.exports = __webpack_public_path__ + "static/media/dfl-logo.f4d531bb.svg";